export function fetchAllEmployeeUsers(apiUrl, accessToken, dealerNumber) {

  return fetch(`${apiUrl}/v1/employee-users/${dealerNumber}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })

}

export function fetchSingleEmployeeUser(apiUrl, accessToken, dealerNumber, userId) {

  return fetch(`${apiUrl}/v1/employee-users/${dealerNumber}/${userId}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })

}

export function fetchSisterStoreUsers(apiUrl, accessToken, dealerNumber){
  return fetch(`${apiUrl}/v1/employee-users/${dealerNumber}/sister-stores`,{
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export function fetchOtherDivisionUsers(apiUrl, accessToken, dealerNumber){
  return fetch(`${apiUrl}/v1/employee-users/${dealerNumber}/other-divisions`,{
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })
}



export function updateEmployeeUserPermissions(apiUrl, token, dealerNumber, employeeUser) {
  return fetch(`${apiUrl}/v1/employee-users/${dealerNumber}/permissions`,
      {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: employeeUser.username,
          permissions: employeeUser.permissions,
        }),
      }
    );
}


export function deleteEmployeeUser(apiUrl, token,dealerNumber,username) {
  return fetch(
    `${apiUrl}/v1/employee-users/${dealerNumber}`,
    {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username,
      }),
    }
  );
}


export function createEmployeeUser(apiUrl, token,dealerNumber,{ username, firstName, lastName, permissions }) {
  return fetch(
    `${apiUrl}/v1/employee-users/${dealerNumber}`,
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username,
        firstName,
        lastName,
        permissions: permissions,
      }),
    }
  );
}
